var _circle, _circle2, _path, _g, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40mm",
    height: "40mm",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-74.421 -78.222)"
  }, /*#__PURE__*/React.createElement("g", null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 94.421,
    cy: 98.222,
    r: 20,
    fill: "#cdcdcd",
    strokeWidth: 0.265
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.421,
    cy: 98.222,
    r: 16.538,
    fill: "#5b5b5b",
    strokeWidth: 0.21912
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3989 -.16712 .16712 1.3989 -50.328 -17.694)",
    d: "m95.947 93.261 4.1184 2.1053-4.5229 0.96766 1.4235 4.4008-3.8824-2.514-2.1053 4.1184-0.96766-4.5229-4.4008 1.4235 2.514-3.8824-4.1184-2.1053 4.5229-0.96766-1.4235-4.4008 3.8824 2.514 2.1053-4.1184 0.96766 4.5229 4.4008-1.4235z",
    fill: "#cbcbcb",
    strokeWidth: 0.265
  })), /*#__PURE__*/React.createElement("circle", {
    id: "color",
    cx: 94.421,
    cy: 98.222,
    r: 20,
    fill: "#ffa600",
    strokeWidth: 0.265,
    style: {
      mixBlendMode: "multiply"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(.26458)",
    d: "m356.87 295.64a75.591 75.591 0 0 0-75.59 75.59 75.591 75.591 0 0 0 45.764 69.4l59.918-138.74a75.591 75.591 0 0 0-30.092-6.25z",
    fillOpacity: 0.20446,
    opacity: 0.7,
    strokeWidth: 1.0016
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(.26458)",
    d: "m356.87 295.64c-41.747 3.9e-4 -75.589 33.843-75.59 75.59 0.0203 27.803 15.302 53.351 39.789 66.52-33.174-18.123-44.023-58.714-28.432-94.659s57.352-57.219 94.286-41.218c-9.486-4.1107-19.714-6.2319-30.053-6.2324z",
    opacity: 0.7,
    strokeWidth: 1.0016
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(.26458)",
    d: "m356.47 435.13c-2.5324-0.23356-6.2291-0.8077-8.4853-1.3178-2.3925-0.54097-5.9491-1.5326-5.8505-1.6312 0.04-0.04 0.81585 0.088 1.7242 0.28435 7.7324 1.6716 17.298 1.7399 25.147 0.1795 14.833-2.949 27.967-11.051 37.265-22.986 7.2471-9.3036 11.536-20.003 12.888-32.148 0.29142-2.6194 0.29142-9.9317 0-12.551-1.351-12.143-5.6368-22.84-12.874-32.131-2.9053-3.7296-6.7536-7.659-10.091-10.304-1.5111-1.1974-0.91659-1.0078 0.86389 0.2755 4.1756 3.0096 8.9624 7.4192 12.21 11.248 8.2987 9.7826 13.461 21.338 15.112 33.828 0.38502 2.9119 0.43907 10.775 0.093 13.523-0.84695 6.7248-2.55 12.578-5.3342 18.334-3.206 6.6279-6.8739 11.848-11.845 16.857-10.101 10.179-22.782 16.307-37.87 18.298-2.4167 0.31889-10.483 0.46909-12.953 0.24121z",
    opacity: 0.7,
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("path", {
    className: "UnoptimicedTransforms",
    d: "m105.59 98.991-6.1654 2.1095 2.7271 5.9192 1.4609 0.51953-2.8027-5.8555 6.166-2.0957zm-13.662 5.0912-5.9384 2.7598 1.4802 0.52591 4.8811-2.3794zm4.4985-10.473-2.1095-6.1654 1.3419 0.73743 1.7745 4.964zm-0.12649 10.541-2.2569 6.1129 0.85853 0.35547 2.3068-6.0231zm3.1769-7.4168 2.8681-5.8511 0.89662 0.42804-2.7598 5.7941z",
    color: "#000000",
    opacity: 0.7,
    style: {
      InkscapeStroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(.26458)",
    d: "m356.48 330.5-8.4844 22.98 3.8438 1.4492 6.8223-18.053zm-30.645 12.264 10.305 22.369-23.303 7.9727 6.2207 2.2969 23.111-7.4648-10.492-22.311zm60.986 0.73242-22.172 10.213 1.7754 3.8711 17.414-8zm-50.951 38.287-10.768 21.967 6.043-2.7832 8.4238-17.387zm15.688 10.508-4.0312 1.3125 7.918 23.143 2.1738-5.8867z",
    color: "#000000",
    fill: "#fff",
    opacity: 0.7,
    strokeWidth: 3.7795,
    style: {
      InkscapeStroke: "none"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "scale(.26458)",
    d: "m321.03 422.3c-5.6758-4.062-10.034-8.2914-14.032-13.619-2.5676-3.4209-3.9709-5.7186-6.0295-9.8723-3.3361-6.7313-5.2263-13.083-6.1289-20.594-0.42471-3.5344-0.42311-10.454 3e-3 -13.965 0.93558-7.7053 2.8835-14.222 6.2778-21.003 8.673-17.326 25.062-29.705 44.128-33.332 3.94-0.7495 7.2449-1.0475 11.579-1.0442 5.5284 4e-3 10.514 0.59961 15.114 1.8046 2.3373 0.61226 2.16 0.64956-0.92782 0.19526-7.2233-1.0627-15.227-0.78324-22.66 0.79124-12.991 2.7519-24.982 9.8005-33.901 19.929-10.359 11.763-15.785 26.149-15.785 41.851 0 7.3602 1.0972 14.004 3.4385 20.821 3.6297 10.569 10.639 20.651 19.373 27.867 2.054 1.6969 2.0503 1.6936 1.8399 1.6906-0.0924-1e-3 -1.1225-0.68555-2.2893-1.5206z",
    opacity: 0.7
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.04ef3faa17b26dd75af4fab5dbabc7b1.svg";
export { ForwardRef as ReactComponent };